import './App.scss';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import {
  BrowserRouter, Route, Routes
} from 'react-router-dom';
import {
  Typography
} from 'tfc-components';
// import { Loading } from 'tfc-components';

import useInitialRender from 'hooks/useInitialRender';
import Home from 'pages/Home';
import Login from 'pages/Login';
import Policy from 'pages/Policy';
import { store } from 'store';

const AppContent: React.FC = () => {
  useInitialRender();
  return (
    <Routes>
      <Route index element={<Home />} />
      <Route
        path="/login"
        element={<Login />}
      />
      <Route
        path="/policy"
        element={<Policy />}
      />
      <Route
        path="*"
        element={(
          <div className="notfound">
            <Typography.Heading
              textStyle="center"
              fontweight="600"
            >
              Not found!
            </Typography.Heading>
          </div>
        )}
      />
    </Routes>
  );
};

const App: React.FC = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </QueryClientProvider>
  );
};

const AppWrapper: React.FC = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;
